
import React from 'react';

const WorksSection: React.FC = () => {
  const works = [
    {
      category: 'テレビ',
      items: [
        'SBSテレビ「静岡発そこ知り」'
      ]
    },
    {
      category: 'ラジオ',
      items: [
        'SBSラジオ キャスタードライバー',
        'FM Hi',
        '「pallet」第2,4火曜日 パーソナリティ',
        '「ひるラジ!静岡情報館」金曜日 パーソナリティ',
        'RADIO LUSH (YAIZU FM)',
        '「エムスタ!」毎週木曜 11:00~13:00',
        '「バズらせRADIO」 毎週木曜 12:00~14:00'
      ]
    },
    {
      category: 'テレビCM',
      items: [
        '「第16回しずおか市町対抗駅伝」(ナレーション)',
        '株式会社ブルクアセット(出演・ナレーション)'
      ]
    },
    {
      category: 'イベントMC',
      items: [
        '「静岡市歴史博物館開館記念イベント はじまりの日~未来への種をまく~」',
        '新文化島2.0 メインステージMC',
        '社交ダンスパーティーMC',
        '発表会の影アナウンス'
      ]
    },
    {
      category: '講師',
      items: [
        '大里中学校放課後サークル活動「アナウンサーの話を聞こう」'
      ]
    },
    {
      category: '舞台出演',
      items: [
        '「STAND UP!~シズオカ独立宣言 家康再起動~(初演)」',
        '「STAND UP!~シズオカ独立宣言 家康再起動~(再演)」',
        '「Action!~シズオカ新撰組血風録~」',
        '「No Woman No Cry」',
        '「Fly me to the Moon~タケトリストーリー~」',
        '「BEAT IT!!~新今川物語2018~」',
        '「君となら なんか変われる気がするの」',
        '「BEAT IT!!~新今川物語2019~」',
        '「Shine a Light(再演)」',
        '「FLASH!~アベハナネヴァーエンド~(初演)」',
        '「Kiss of Life」',
        '「FLASH!~アベハナネヴァーエンド~(再演)」',
        '「TRUST!!」',
        '「TWINKLE」'
      ]
    }
  ];

  const currentWorks = [
    'RADIO LUSH (YAIZU FM)',
    '「エムスタ!」毎週木曜 11:00~13:00'
  ];

  return (
    <section id="works" className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">実績・出演歴</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            これまでの豊富な経験と実績をご紹介いたします
          </p>
        </div>

        <div className="mb-12 bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <h3 className="text-xl font-bold text-red-700 mb-3">現在出演中</h3>
          <div className="space-y-2">
            {currentWorks.map((work, index) => (
              <p key={index} className="text-red-600 font-medium">{work}</p>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {works.map((category, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-mic-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">{category.category}</h3>
              </div>
              <div className="space-y-3">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="flex items-start">
                    <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <p className="text-gray-700 text-sm leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorksSection;
